import { render } from "./Index.vue?vue&type=template&id=5e3796f6&scoped=true"
import script from "./Index.vue?vue&type=script&lang=ts"
export * from "./Index.vue?vue&type=script&lang=ts"

import "./Index.vue?vue&type=style&index=0&id=5e3796f6&lang=scss"
import "./Index.vue?vue&type=style&index=1&id=5e3796f6&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-5e3796f6"

export default script